// src/pages/finance/ReferralManagementPage.js
import React, { useEffect, useState } from 'react'
import { collection, getDocs, query } from 'firebase/firestore'
import { db } from '../../firebaseConfig'

export default function ReferralManagementPage() {
  const [loading, setLoading] = useState(true)
  const [topReferrers, setTopReferrers] = useState([])
  const [stats, setStats] = useState({
    totalBonusPaid: 0,
    totalMitraJoinedViaReferral: 0
  })

  useEffect(() => {
    fetchReferralData()
  }, [])

  const fetchReferralData = async () => {
    setLoading(true)
    try {
      const therapistsRef = collection(db, 'therapists')
      const cleanersRef = collection(db, 'cleaners')
      const referralsRef = collection(db, 'referrals') // KOLEKSI DRIVER

      // Ambil data dari 3 koleksi sekaligus
      const [tSnap, cSnap, rSnap] = await Promise.all([
        getDocs(query(therapistsRef)),
        getDocs(query(cleanersRef)),
        getDocs(query(referralsRef))
      ])

      let allMitra = []
      let totalBonus = 0
      let totalReferred = 0

      // 1. PROSES THERAPIST & CLEANER (Struktur Lama)
      const processDoc = (doc, type) => {
        const data = doc.data()
        totalBonus += (data.referralBonus || 0)
        if (data.referredBy) totalReferred++

        if ((data.totalReferrals || 0) > 0 || (data.referralBonus || 0) > 0) {
          allMitra.push({
            id: doc.id,
            name: data.name,
            type: type,
            totalReferrals: data.totalReferrals || 0,
            referralBonus: data.referralBonus || 0,
            referralCode: data.referralCode || '-'
          })
        }
      }

      tSnap.forEach(d => processDoc(d, 'Therapist'))
      cSnap.forEach(d => processDoc(d, 'Cleaner'))

      // 2. PROSES DRIVER DARI KOLEKSI 'referrals' (Struktur Baru)
      const driverStats = {}
      rSnap.forEach(doc => {
        const data = doc.data()
        const uid = data.referredByUid
        if (!uid) return

        totalReferred++ // Hitung total orang yang bergabung via referral

        // Buat agregat profil pengundang
        if (!driverStats[uid]) {
          driverStats[uid] = {
            id: uid,
            name: data.referredByName || 'Driver Zimo',
            type: 'Driver',
            totalReferrals: 0,
            referralBonus: 0,
            referralCode: data.referredByIdNumber || '-'
          }
        }

        driverStats[uid].totalReferrals += 1

        // Bonus cair jika statusnya active
        if (data.status === 'active' || data.status === 'aktif') {
          driverStats[uid].referralBonus += 20000
          totalBonus += 20000
        }
      })

      // Masukkan data agregat driver ke dalam list utama
      Object.values(driverStats).forEach(stat => {
        allMitra.push(stat)
      })

      // Sortir berdasarkan jumlah referral terbanyak
      allMitra.sort((a, b) => b.totalReferrals - a.totalReferrals)

      setTopReferrers(allMitra)
      setStats({
        totalBonusPaid: totalBonus,
        totalMitraJoinedViaReferral: totalReferred
      })

    } catch (error) {
      console.error("Error fetching referral:", error)
    }
    setLoading(false)
  }

  return (
    <div>
      {/* STATISTIK CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-gray-800 p-5 rounded-lg border border-gray-700">
          <p className="text-gray-400 text-sm">Total Bonus Referral Dibayarkan</p>
          <p className="text-2xl font-bold text-green-400 mt-1">
            Rp {stats.totalBonusPaid.toLocaleString('id-ID')}
          </p>
        </div>
        <div className="bg-gray-800 p-5 rounded-lg border border-gray-700">
          <p className="text-gray-400 text-sm">Total Mitra Bergabung via Referral</p>
          <p className="text-2xl font-bold text-blue-400 mt-1">
            {stats.totalMitraJoinedViaReferral} Orang
          </p>
        </div>
      </div>

      {/* TABLE TOP REFERRERS */}
      <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-700">
          <h3 className="text-lg font-bold text-white">🏆 Top Mitra Referrer</h3>
        </div>
        
        {loading ? (
          <div className="p-6 text-gray-400 text-center">Loading data...</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm text-gray-300">
              <thead className="bg-gray-700 text-gray-400 uppercase font-semibold">
                <tr>
                  <th className="px-6 py-3">Nama Mitra</th>
                  <th className="px-6 py-3">Tipe</th>
                  <th className="px-6 py-3">Kode Referral</th>
                  <th className="px-6 py-3 text-center">Total Mengajak</th>
                  <th className="px-6 py-3 text-right">Bonus Diterima</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {topReferrers.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-6 py-4 text-center">Belum ada data referral.</td>
                  </tr>
                ) : (
                  topReferrers.map((mitra, index) => (
                    <tr key={mitra.id} className="hover:bg-gray-700/50">
                      <td className="px-6 py-3 font-medium text-white">
                        {index + 1}. {mitra.name}
                      </td>
                      <td className="px-6 py-3">
                        <span className={`px-2 py-1 rounded text-xs ${
                          mitra.type === 'Cleaner' ? 'bg-orange-900 text-orange-200' : 
                          mitra.type === 'Driver' ? 'bg-blue-900 text-blue-200' : 
                          'bg-purple-900 text-purple-200'
                        }`}>
                          {mitra.type}
                        </span>
                      </td>
                      <td className="px-6 py-3 font-mono text-yellow-500">
                        {mitra.referralCode}
                      </td>
                      <td className="px-6 py-3 text-center font-bold text-white">
                        {mitra.totalReferrals}
                      </td>
                      <td className="px-6 py-3 text-right font-bold text-green-400">
                        Rp {mitra.referralBonus.toLocaleString('id-ID')}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}